export enum ElementName {
    marketingHeader1 = 'marketing-header-1',
    marketingHeader2 = 'marketing-header-2',
    marketingSubheader = 'marketing-subheader',
    uploadLabel = 'upload-label',
    uploadBtnLabel = 'upload-btn-label',
    fileInput = 'file-input',
    dragDropZone = 'drag-drop-zone',
    mobilePreview = 'mobile-preview',
    desktopPreview = 'desktop-preview',
    progressLabel = 'progress-label',
    progress = 'progress',
    uploadBtn = 'upload-btn',
    headerMain = 'header-main',
}

export const ElementIdMap: Record<string, string> = {
    [ElementName.marketingHeader1]: '#marketing-header-1',
    [ElementName.marketingHeader2]: '#marketing-header-2',
    [ElementName.marketingSubheader]: '#marketing-subheader',
    [ElementName.uploadLabel]: '#upload-label',
    [ElementName.uploadBtnLabel]: '#upload-btn-label',
    [ElementName.fileInput]: '#file-input',
    [ElementName.dragDropZone]: '#drag-drop-zone',
    [ElementName.mobilePreview]: '#mobile-preview',
    [ElementName.desktopPreview]: '#desktop-preview',
    [ElementName.progressLabel]: '#uploading-label',
    [ElementName.progress]: '#progress',
    [ElementName.uploadBtn]: '#upload-btn',
    [ElementName.headerMain]: '#header-main',
};
